import { useEffect } from "react";
import { Input, Radio } from "@gamesb42/ui-kit";

import { corparateDoc } from "./index";
import { observer } from "mobx-react";
import UploadFile from "components/UploadFile";

import { ReactComponent as Pdf } from "./assets/pdf.svg";
import { ReactComponent as Close } from "./assets/close.svg";

import s from "./styles.module.scss";
import { authorizedRequest } from "utils/authorization";
import FileName from "./components/FileName";

const Step7 = observer(() => {
  useEffect(() => {
    const conditionForUpload =
      corparateDoc.values.step7Variant === "upload" &&
      corparateDoc.values.latestAuditedFinancialStatementFile!.name.length > 0;
    const conditionForNotApplicable =
      corparateDoc.values.step7Variant === "notApplicable" &&
      corparateDoc.values.latestAuditedFinancialStatementComment.length > 0;

    if (conditionForUpload || conditionForNotApplicable) {
      corparateDoc.isStepIsValid[7] = true;
    } else {
      corparateDoc.isStepIsValid[7] = false;
    }
  }, [
    corparateDoc.values.step7Variant,
    corparateDoc.values.latestAuditedFinancialStatementComment,
    corparateDoc.values.latestAuditedFinancialStatementFile!.name,
  ]);

  function delFileHandler() {
    if (
      corparateDoc.values.latestAuditedFinancialStatementFile?.docId?.length > 0
    ) {
      corparateDoc.values.needtoDelete.push(
        corparateDoc.values.latestAuditedFinancialStatementFile.docId
      );
    }

    corparateDoc.values.latestAuditedFinancialStatementFile = {
      id: "",
      docId: "",
      name: "",
      value: "",
      size: 0,
    };

    corparateDoc.values.latestAuditedFinancialStatementComment = "";
  }

  return (
    <>
      <p>Latest Audited Financial Statement or Management Accounts*</p>
      <Radio.Group value={corparateDoc.values.step7Variant}>
        <Radio
          value="upload"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step7Variant = "upload";
          }}
        >
          Upload
        </Radio>
        <Radio
          value="notApplicable"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step7Variant = "notApplicable";
          }}
        >
          Not applicable
        </Radio>
      </Radio.Group>

      {corparateDoc.values.step7Variant === "upload" && (
        <div
          style={{
            marginTop: "32px",
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <div className={s.uploadHolder}>
            {(corparateDoc.values.latestAuditedFinancialStatementFile!.size ===
              0 && (
              <UploadFile
                dragText="Drag and drop file*"
                uploadText={`50 Mb max. weight`}
                onUpload={(e, file) => {
                  corparateDoc.values.latestAuditedFinancialStatementFile!.name =
                    file.name;
                  corparateDoc.values.latestAuditedFinancialStatementFile!.size =
                    file.size;
                  corparateDoc.values.latestAuditedFinancialStatementFile!.value =
                    file;
                }}
              />
            )) || (
              <FileName
                fileName="latestAuditedFinancialStatementFile"
                clearFiles={delFileHandler}
              />
            )}
          </div>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Comment to the uploaded file"
            disabled={
              corparateDoc.values.latestAuditedFinancialStatementFile.docId
                ?.length > 0
            }
            showCount={true}
            maxLength={200}
            value={corparateDoc.values.latestAuditedFinancialStatementComment}
            onChange={(e) => {
              corparateDoc.values.latestAuditedFinancialStatementComment =
                e.target.value;
            }}
            placeholder="Not applicable? Please explain why*"
          />
        </div>
      )}

      {corparateDoc.values.step7Variant === "notApplicable" && (
        <div style={{ padding: "32px 0 0 0" }}>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Not applicable? Please explain why*"
            disabled={false}
            showCount={true}
            maxLength={200}
            value={corparateDoc.values.latestAuditedFinancialStatementComment}
            onChange={(e) => {
              corparateDoc.values.latestAuditedFinancialStatementComment =
                e.target.value;
            }}
            placeholder="Not applicable? Please explain why*"
          />
        </div>
      )}
    </>
  );
});

export default Step7;
